import React, { Component } from "react";
import { connect } from "react-redux";
import { updateGlobalSuccessMessage } from "../../actions/globalSuccess";
@connect(mapStateToProps)
export default class GlobalSuccess extends Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(props) {
    let { message } = this.props;

    if (message != props.message && props.message != "") {
      setTimeout(() => {
        if (this.globalSuccess) {
          //if message hasnt been removed yet by another one
          this.globalSuccess.className =
            this.globalSuccess.className + " msgFadedOut";
        }
        setTimeout(() => {
          if (props.message == this.props.message) {
            // if the message is still the same
            let data = {
              message: "",
              icon: ""
            };
            this.props.dispatch(updateGlobalSuccessMessage(data));
          }
        }, 300);
      }, 4200);
    }
  }

  render() {
    let { message, icon, animation, customMessage } = this.props;
    let successElement = <span></span>;

    if (customMessage) {
      message = customMessage;
    }

    if (message) {
      successElement = (
        <div
          className={`good-message-toaster-notification SavedConfirmBox ${animation ||
            "msgFadeIn"}`}
          ref={input => {
            this.globalSuccess = input;
          }}
        >
          <div id="advanced_confirm_msg">
            <div className={icon}></div>
            <div
              className="savedText"
              dangerouslySetInnerHTML={{ __html: message }}
            ></div>
          </div>
        </div>
      );
    }

    return successElement;
  }
}
function mapStateToProps(state) {
  return {
    message: state.globalSuccessReducer.message,
    icon: state.globalSuccessReducer.icon,
    animation: state.globalSuccessReducer.animation
  };
}
